module.exports = __webpack_public_path__ + "media/KikiSA.f812b22d.mp3";